<script lang="ts">
	import type { CloudImage } from "$lib/def/seo/cloud-image";
	import type { Options } from "flickity";
	import type { CarouselType } from "$lib/ui/layout/Carousel.svelte";
	
	import { getCimgUrl } from "$lib/serv/admin/editImg";

	import Carousel from "$lib/ui/layout/Carousel.svelte";
	import LazyBackgroundImage from "../LazyBackgroundImage.svelte";
import { imgSrc, toSrc } from "$lib/serv/image-details";

	export let title: string;
	export let list: undefined | { slug?:string, vertical?:string, name?:string, logo?:string }[];
	export let type: CarouselType = 'brands';

	const options: Options & { fade: boolean } = {
		freeScroll: true,
		wrapAround: false,
		groupCells: true,
		pageDots: false,
		prevNextButtons: false,
		draggable: true,
		selectedAttraction: 0.025,
		friction: 0.28,
		fade: false,
	}
</script>

<div class="m-xxl">
	<Carousel cache={{ loading: !list, payload: list }} {type} key={l => l} {options} let:item={item}>
		<div slot="title" class="flex mobile flex-nowrap title">
			<h3 class="title headline-m bold">{title}</h3>
			<a href="/delivery/restaurants-near-me" class="button transparent label-xl bold underlined">See all</a>
		</div>
		
		<a class="item" href={`/delivery/${item.vertical}s/${item.slug}-near-me`} style="margin-top: 8px; width: 80px;">
			<article class="brand">
				<LazyBackgroundImage image={imgSrc(item.logo, '80x80')} alt={`${item.name ?? 'Mr D'} near me`} />
			</article>
			<div class="label-xl medium ellipses m-tiny text-center">{item.name}</div>
		</a>
	</Carousel>
</div>
